export type PatientsTabId =
  | 'my-patient-directory'
  | 'my-prospects'
  | 'waitlist'
  | 'reciprocity-visit'
  | 'my-events'
  | 'my-initiatives';

export type PatientsTab = {
  /** Also the tab's route segment under `/patients`. */
  id: PatientsTabId;
  labelKey: string;
  /** False until the tab's own page ships; the tab bar renders it disabled with a "Coming soon" label. */
  available: boolean;
};

/* Design order. `as const satisfies` rather than an annotation: the literal `labelKey` types are
   what let t() key-check the labels, and the annotation would widen them. */
export const PATIENTS_TABS = [
  { id: 'my-patient-directory', labelKey: 'pages.patients.tabs.myPatientDirectory', available: true },
  { id: 'my-prospects', labelKey: 'pages.patients.tabs.myProspects', available: false },
  { id: 'waitlist', labelKey: 'pages.patients.tabs.waitlist', available: false },
  { id: 'reciprocity-visit', labelKey: 'pages.patients.tabs.reciprocityVisit', available: false },
  { id: 'my-events', labelKey: 'pages.patients.tabs.myEvents', available: false },
  { id: 'my-initiatives', labelKey: 'pages.patients.tabs.myInitiatives', available: false },
] as const satisfies readonly PatientsTab[];

/** Where `/patients` lands: the first tab that has a page. */
export const DEFAULT_PATIENTS_TAB: PatientsTabId = 'my-patient-directory';

/** The tab whose route segment is `segment`, or undefined for anything that isn't a Patients tab. */
export function findPatientsTab(segment: string | undefined): (typeof PATIENTS_TABS)[number] | undefined {
  return PATIENTS_TABS.find((tab) => tab.id === segment);
}
